const locale = {
    lang: {
        by_contact: "按联系人",
        by_session: "按会话",
        by_org: "按组织架构",
        by_batch_import: "批量导入",
        useradd_type_partner: "我的伙伴",
        useradd_type_group: "我的群组",
        useradd_type_org: "组织架构",
        useradd_type_session: "最近会话",
        common_tal: "好未来教育科技集团",
        useradd_all_org: "按组织架构选择",
        useradd_all_contacts: "常用联系人",
        useradd_recent_connect: "最近联系人",
        common_persion: "人",
        common_select_overrun: "选择数量超限",
        useradd_all_select: "全选",
        useradd_all_child: "下级",
        useradd_select_noresult: "没有匹配任何结果",
        common_ok: "确定 ",
        useradd_select_search: "搜索",
        useradd_type_contact: "外部联系人",
        selected: "已选：",
        recent_forward_title: "最近转发",

        partner_view: "查看",

        sessionPickerTitleDefault: "选择会话",
        groupPickerTitleDefault: "我的群组",
        userPickerTitleDefault: "选择用户",
        orgPickerTitleDefault: "选择部门",

        searchPlaceholderDefault: "搜索",

        batch_import: "批量导入",
        batch_import_tips: "请输入需要导入的员工工号",
        batch_import_tips1: "每行一个，回车换行分隔",
        batch_import_placeholder: "请输入工号",
        batch_import_input_limit_exceed: "已超出最大限制，不可继续输入",
        batch_import_paste_limit_exceed:
            "超出最大限制，有 [xxx] 条工号粘贴失败",
        batch_import_error: "[xxx] 个工号校验失败，请检查后再试",
        batch_import_confirm: "确认导入",
        batch_import_workcode_format_error: "请输入正确的工号格式",
        batch_importing: "导入中...",

        batch_view_more_contacts: "查看更多联系人",
        batch_view_more_groups: "查看更多群组",
        batch_contacts: "联系人",
        batch_groups: "群组",

        common_manager1: "群主",
        common_manager2: "管理员",

        cancel: "取消",

        search_tab_title_user: "联系人",
        search_tab_title_group: "群聊",
        search_tab_title_org: "部门",
        search_loading_text: "搜索中",
        search_tips_text: "请输入想要搜索的关键词",
        search_no_result_text: "没有找到符合“[xxx]”的结果",

        load_more_text: "加载更多",
        selected_count_org_text: "部门",
        selected_count_group_text: "群组",
        selected_count_people_text: "人",
    },
};

export default locale;
